import * as React from "react";
import {
  Building2,
  FileText,
  FolderOpen,
  Bell,
  Search,
  Sparkles,
  Eye,
  ChevronRight,
  Target,
} from "lucide-react";
import { DashboardGlyph, SubscriptionsGlyph, WealthScopeGlyph } from "./appCustomIcons";

const NAV_ITEMS = [
  { icon: DashboardGlyph, label: "Dashboard", chevron: false },
  { icon: WealthScopeGlyph, label: "WealthScope", chevron: true },
  { icon: Building2, label: "Portfolio IQ", chevron: true },
  { icon: Target, label: "DealHunterIQ", chevron: true },
  { icon: FileText, label: "Reports & Data", chevron: false },
  { icon: FolderOpen, label: "Documents", chevron: false },
  { icon: Bell, label: "Alerts & Insights", chevron: false },
  { icon: SubscriptionsGlyph, label: "My Subscriptions", chevron: false },
];

/* ─── Shared fake sidebar — real app nav/icon set, highlights active item ── */
export const AppSidebar: React.FC<{ activeLabel: string }> = ({ activeLabel }) => (
  <div className="flex w-[120px] shrink-0 flex-col gap-0.5 border-r border-gray-200 bg-white px-1.5 py-3">
    <div className="mb-3 flex items-center gap-1.5 px-1.5">
      <div className="w-5 h-5 rounded bg-blue-600 flex items-center justify-center">
        <span className="text-white text-[9px] font-bold">V</span>
      </div>
      <span className="text-[10px] font-bold text-gray-900">VaWeNa</span>
    </div>
    {NAV_ITEMS.map(({ icon: ItemIcon, label, chevron }) => {
      const active = label === activeLabel;
      return (
        <div
          key={label}
          className={`flex items-center gap-1.5 rounded-md px-1.5 py-1.5 ${
            active ? "bg-blue-600 text-white" : "text-gray-500"
          }`}
        >
          <ItemIcon className="w-2.5 h-2.5 shrink-0" />
          <span className="flex-1 truncate font-medium text-[7px]">{label}</span>
          {chevron && <ChevronRight className="w-2 h-2 shrink-0 opacity-60" />}
        </div>
      );
    })}
  </div>
);

/* ─── Shared fake top bar — search, Hide Details, bell, AI Assistance, avatar ── */
export const AppTopBar: React.FC = () => (
  <div className="mb-2 flex items-center gap-1.5">
    <div className="flex-1 flex items-center gap-1.5 rounded-full border border-gray-200 bg-white px-2 py-1 text-gray-400">
      <Search className="w-2.5 h-2.5" />
      <span className="text-[9px]">Search or ask anything...</span>
    </div>
    <div className="flex items-center gap-1 rounded-full border border-gray-200 bg-white px-2 py-1 text-gray-500">
      <Eye className="w-2.5 h-2.5" />
      <span className="text-[8px] font-medium">Hide Details</span>
    </div>
    <div className="relative shrink-0 w-6 h-6 rounded-full border border-gray-200 bg-white flex items-center justify-center">
      <Bell className="w-2.5 h-2.5 text-gray-500" />
      <span className="absolute -top-0.5 -right-0.5 w-3 h-3 rounded-full bg-rose-500 text-white text-[6px] font-bold flex items-center justify-center">
        3
      </span>
    </div>
    <div className="flex items-center gap-1 rounded-full bg-blue-600 px-2 py-1 text-white font-semibold shrink-0">
      <Sparkles className="w-2.5 h-2.5" />
      <span className="text-[8px]">AI Assistance</span>
    </div>
    <div className="w-5 h-5 rounded-full bg-purple-500 flex items-center justify-center text-white text-[8px] font-bold shrink-0">
      U
    </div>
  </div>
);
